import './InitiativeSubSection.scss';
import classNames from 'classnames';
import { InitiativeSectionProps } from './InitiativeSection';
import React from 'react';
import { SonarText } from '@ui/text';

export interface InitiativeSubSectionProps extends InitiativeSectionProps {
	bold?: boolean;
	direction?: 'horizontal' | 'vertical';
	reducedPadding?: boolean;
}

function getTitle(title: string, count: number | undefined): string {
	if (!Number.isInteger(count)) {
		return title;
	}

	return `${count} ${title}`;
}

export const InitiativeSubSection: React.FC<InitiativeSubSectionProps> = ({
	bold,
	children,
	className,
	count,
	direction = 'vertical',
	icon,
	id,
	reducedPadding = false,
	title
}) =>
	<div
		className={ classNames('initiative-sub-section', className) }
		id={ id }>
		<div className={ classNames('sub-section-header', { 'reduced-padding': reducedPadding }) }>
			<SonarText
				className='sub-section-title'
				weight={ bold ? 'semibold' : undefined }>
				{ icon }
				{ getTitle(title, count) }
			</SonarText>
			{ direction === 'horizontal' ? <div className='sub-section-children'>{ children }</div> : null }
		</div>
		{ direction === 'vertical' ? children : null }
	</div>;

